/* ArabEsq conversion layer: welcome popup + cart boosters (drawer + cart page) */
(function () {
  if (window.__arbConv) return;
  window.__arbConv = true;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    /* ---- welcome popup ---- */
    var overlay = document.getElementById("arbOverlay");
    if (overlay) {
      var seen = false;
      try { seen = localStorage.getItem("arb_welcome_seen") === "1"; } catch (e) {}
      var markSeen = function () { try { localStorage.setItem("arb_welcome_seen", "1"); } catch (e) {} };
      var close = function () { overlay.classList.remove("show"); markSeen(); };
      overlay.querySelectorAll("[data-arb-pop-close]").forEach(function (b) { b.addEventListener("click", close); });
      overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
      if (document.getElementById("arbPopSuccessFlag")) {
        overlay.classList.add("show");
        markSeen();
      } else if (!seen) {
        setTimeout(function () { overlay.classList.add("show"); }, 6000);
      }
    }

    /* ---- cart boosters ----
       The add-on matches the cart and is never blank.
       No hat in the cart: a homeland piece (country hoodie, crew, or tee) gets that same
       country's Baladi dad hat; anything else gets the maté dad hat.
       A hat already in the cart: the maté tee, then the maté tank, then the maté hat,
       then any Baladi dad hat the cart does not hold yet. */
    var HATS_COLLECTION = "baladi-caps";
    var MATE_HAT = "dads-embroidered-mate-hat";
    var MATE_LADDER = ["its-mate-time", "mate", MATE_HAT];
    var SHIPNOTE = "<b>Free US shipping over $75.</b> Made to order · 5–7 day craft time.";
    var hatsCache = null;
    var productCache = {};

    function getJSON(url) {
      return fetch(url, { credentials: "same-origin" }).then(function (r) {
        if (!r.ok) throw new Error(url);
        return r.json();
      });
    }
    function loadHats() {
      if (hatsCache) return Promise.resolve(hatsCache);
      return getJSON("/collections/" + HATS_COLLECTION + "/products.json?limit=50")
        .then(function (d) { hatsCache = d.products || []; return hatsCache; })
        .catch(function () { return []; });
    }
    function loadProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return getJSON("/products/" + handle + ".js")
        .then(function (p) { productCache[handle] = p; return p; })
        .catch(function () { return null; });
    }
    function priceLabel(v) {
      var p = v.price;
      var n = typeof p === "number" ? p / 100 : parseFloat(p);
      if (isNaN(n)) return "";
      return "$" + (Math.round(n * 100) % 100 === 0 ? n.toFixed(0) : n.toFixed(2));
    }
    function imageFor(p, v) {
      var src = (v.featured_image && v.featured_image.src) || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || p.featured_image || "";
      if (src && src.indexOf("//") === 0) src = "https:" + src;
      if (src) src += (src.indexOf("?") > -1 ? "&" : "?") + "width=120";
      return src;
    }
    function toPick(p, label, isCountryHat) {
      if (!p || !p.variants || !p.variants.length) return null;
      var v = null;
      for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available !== false) { v = p.variants[i]; break; } }
      if (!v) return null;
      return {
        variantId: String(v.id),
        img: imageFor(p, v),
        label: label,
        name: (isCountryHat && !/hat/i.test(p.title)) ? p.title + " dad hat" : p.title,
        price: priceLabel(v)
      };
    }
    function isHatItem(item, hatIds) {
      if (hatIds[item.product_id]) return true;
      var t = (item.product_title || "").toLowerCase();
      var h = (item.handle || "").toLowerCase();
      var pt = (item.product_type || "").toLowerCase();
      return pt === "hat" || /\b(hat|cap)\b/.test(t) || /(^|-)(hat|cap)(-|$)/.test(h);
    }
    function isMateItem(item) {
      return /mat[eé]/i.test(item.handle || "") || /mat[eé]\b/i.test(item.product_title || "");
    }
    function countryHatFor(items, hats) {
      for (var j = 0; j < items.length; j++) {
        var title = (items[j].product_title || "").trim().toLowerCase();
        var key = (items[j].handle || "").replace(/-(1|2|crew|hoodie|hat|dad-hat)$/, "").replace(/^uae$/, "united-arab-emirates").replace(/^saudi$/, "saudi-arabia");
        for (var k = 0; k < hats.length; k++) {
          if (title === hats[k].title.trim().toLowerCase() || key === (hats[k].handle || "").replace(/-1$/, "")) return hats[k];
        }
      }
      return null;
    }
    function ladderPick(handles, inCart, label) {
      if (!handles.length) return Promise.resolve(null);
      return loadProduct(handles[0]).then(function (p) {
        if (p && !inCart[p.id]) { var pick = toPick(p, label, false); if (pick) return pick; }
        return ladderPick(handles.slice(1), inCart, label);
      });
    }
    function pickUpsell() {
      return getJSON("/cart.js").then(function (cart) {
        var items = cart.items || [];
        if (!items.length) return null;
        return loadHats().then(function (hats) {
          var hatIds = {}, inCart = {}, hasHat = false, hasMate = false;
          hats.forEach(function (h) { hatIds[h.id] = true; });
          items.forEach(function (it) {
            inCart[it.product_id] = true;
            if (isHatItem(it, hatIds)) hasHat = true;
            if (isMateItem(it)) hasMate = true;
          });
          if (!hasHat) {
            var match = countryHatFor(items, hats);
            if (match) return toPick(match, "Match your " + match.title.replace(/\s*dad hat$/i, "") + " piece", true);
            return loadProduct(MATE_HAT).then(function (p) { return toPick(p, "Complete the fit", false); });
          }
          var label = hasMate ? "Match your maté" : "Complete the fit";
          return ladderPick(MATE_LADDER, inCart, label).then(function (pick) {
            if (pick) return pick;
            for (var k = 0; k < hats.length; k++) {
              if (!inCart[hats[k].id]) { var alt = toPick(hats[k], "Complete the fit", true); if (alt) return alt; }
            }
            return null;
          });
        });
      }).catch(function () { return null; });
    }
    function upsellHTML(pick) {
      return '<img src="' + pick.img + '" alt="' + pick.name + '"><div class="um"><b>' + pick.label + '</b>' + pick.name + ' · ' + pick.price + '</div><button type="button" data-arb-add="' + pick.variantId + '">Add</button>';
    }
    function renderUpsell(container, pick, insert) {
      var existing = container.querySelector(".arb-upsell");
      if (!pick) { if (existing) existing.remove(); return; }
      if (existing && existing.getAttribute("data-arb-variant") === pick.variantId) return;
      if (existing) existing.remove();
      var up = document.createElement("div");
      up.className = "arb-upsell";
      up.setAttribute("data-arb-variant", pick.variantId);
      up.innerHTML = upsellHTML(pick);
      insert(up);
    }

    function enhanceDrawer() {
      var drawer = document.querySelector("cart-drawer");
      if (!drawer) return;
      var inner = drawer.querySelector(".drawer__inner");
      if (!inner) return;
      var header = inner.querySelector(".drawer__header");
      if (header && !inner.querySelector(".arb-shipnote")) {
        var note = document.createElement("div");
        note.className = "arb-shipnote";
        note.innerHTML = SHIPNOTE;
        header.insertAdjacentElement("afterend", note);
      }
      var footer = inner.querySelector(".drawer__footer");
      if (!footer || drawer.classList.contains("is-empty")) {
        var ex = inner.querySelector(".arb-upsell");
        if (ex) ex.remove();
        return;
      }
      pickUpsell().then(function (pick) {
        var f = inner.querySelector(".drawer__footer");
        if (!f) return;
        renderUpsell(inner, pick, function (up) { f.insertAdjacentElement("beforebegin", up); });
      });
    }

    function enhanceCartPage() {
      var footer = document.querySelector(".cart__footer");
      if (!footer) return;
      if (!document.querySelector(".cart__footer .arb-shipnote")) {
        var note = document.createElement("div");
        note.className = "arb-shipnote";
        note.innerHTML = SHIPNOTE;
        footer.insertAdjacentElement("afterbegin", note);
      }
      var main = document.querySelector("#main-cart-items, cart-items");
      if (!main) return;
      pickUpsell().then(function (pick) {
        renderUpsell(footer, pick, function (up) {
          var ctas = footer.querySelector(".cart__ctas");
          if (ctas) ctas.insertAdjacentElement("beforebegin", up);
          else footer.appendChild(up);
        });
      });
    }

    enhanceDrawer();
    enhanceCartPage();
    var drawerEl = document.querySelector("cart-drawer");
    if (drawerEl) {
      var mo = new MutationObserver(function () {
        clearTimeout(window.__arbDrawerT);
        window.__arbDrawerT = setTimeout(enhanceDrawer, 120);
      });
      mo.observe(drawerEl, { childList: true, subtree: true });
    }
    var cartItemsEl = document.querySelector("cart-items");
    if (cartItemsEl) {
      var mo2 = new MutationObserver(function () {
        clearTimeout(window.__arbCartT);
        window.__arbCartT = setTimeout(enhanceCartPage, 200);
      });
      mo2.observe(cartItemsEl, { childList: true, subtree: true });
    }
  });
})();
